export default "__VITE_ASSET__C0ZBIwB8__"